import { Typography } from '@material-ui/core'
import { colors, HealtheraButton } from '../../../healtheraComponents'
import styled from 'styled-components'

export const DetailsLabel = styled(Typography)`
  && {
    font-family: 'Assistant', sans-serif;
    color: ${colors.DARK};
    font-size: 16px;
    font-weight: 800;
  }
`;

export const SettingsLabel = styled(DetailsLabel)`
  && {
    margin-top: 1rem;
    margin-bottom: 0.3rem;
  }
`

export const TitleContainer = styled.span`
  margin: 0;
  margin-right: 5px;
`;

export const ActionButton = styled(HealtheraButton).attrs({
  width: 'auto',
  height: 'auto',
  padding: '0 5px'
})`
  && {
    font-size: 12px;
    min-width: 50px;
  }
`;

export const OrganisationCheckbox = ({ disabled = false, onChange, children, className, checked }) => {
  const handleCheckboxToggle = () => {
    if (disabled) return;
    onChange(!checked);
  };

  return (
    <>
    <List>
      <Button disabled={disabled} active={checked} className={className}>
        <Label>{children}</Label>
        <HiddenInput type='checkbox' value={checked} onChange={handleCheckboxToggle} />
      <RemoveButton>x</RemoveButton>
      </Button>
    </List>
    </>
    
  )
};

const getActiveStyles = () => `
  background-color: #EFEFEF;
  color: black;
`;

const getDisabledStyles = () => `
  background-color: ${colors.FADED_LIGHT};
  color: ${colors.GRAY};
  cursor: default;
`;

const List = styled.ul`
  padding: 0;
`;

const Button = styled.label`
  padding: 0;
  list-style: none;
  border-radius: 3px;
  cursor: pointer;
  background-color: #EFF9F1;
  transition: all .2s ease;
  margin: 2px;
  height: 35px;

  ${(props) => props.active && getActiveStyles()};
  ${(props) => props.disabled && getDisabledStyles()};
`;

const HiddenInput = styled.input`
  display: none;
`;

const Label = styled.span`
  padding: 6px 16px;
`;

const RemoveButton = styled.span`
  float: right;
  margin-right: 30px;
  border-radius: 3px;
  padding: 3px;
  border: 0.5px solid black;
`;
